// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (prefers-color-scheme: dark) {\n.c-fathom-affiliate-banner {\n    background-color: rgb(48, 48, 52)\n}\n}\n.t-light .c-fathom-affiliate-banner {\n    background-color: rgb(246, 246, 246)\n}\n.t-dark .c-fathom-affiliate-banner {\n    background-color: rgb(48, 48, 52)\n}\n.c-fathom-affiliate-banner__logo {\n  -webkit-transform: translateY(1px);\n      -ms-transform: translateY(1px);\n          transform: translateY(1px);\n}\n", ""]);
// Exports
module.exports = exports;
